"use client";
import { jsx as o } from "react/jsx-runtime";
import { mergeRefs as c } from "../../helpers/mergeRefs.js";
import l from "../../styles/components/InputWrapper.js";
import { forwardRef as d, useRef as x } from "react";
const R = d(
  ({
    className: p,
    feAdornment: n,
    feSeverity: u,
    feSize: f = "md",
    onChange: e,
    type: m = "text",
    ...i
  }, s) => {
    const r = x(null), a = c([s, r]);
    return /* @__PURE__ */ o(
      l,
      {
        className: p,
        "data-comp": "input-text",
        feSeverity: u,
        feSize: f,
        feAdornment: n,
        onClick: () => {
          var t;
          return (t = r.current) == null ? void 0 : t.focus();
        },
        children: /* @__PURE__ */ o(
          "input",
          {
            ...i,
            onChange: (t) => e && e(t, t.target.value),
            ref: a,
            type: m
          }
        )
      }
    );
  }
);
R.displayName = "InputText";
export {
  R as default
};
